__turbopack_context__.v({
  "fallback": "_0dTLuG_fallback",
});
